const pictogramEn = {
	pictogramTable: 'Pictogram',
	pictogramEditForm: 'Pictogram',
	name: 'Name',
	file: 'Pictogram'
};

export default pictogramEn;
